module.exports = __webpack_public_path__ + "static/logo_icda-c1847ab9e18d03e3fe2534322814f829.svg";